import HashTable from './hashtable';
import { LOG, display_message_to_user } from '@phi/logging/frontend';
import * as THREE from 'three';
import * as maths from './maths';
import { get_global_id } from './JCore/jcore';
import { Uid_edge, Uid_face, Uid_ref_edge, Uid_ref_face, Uid_ref_vertex, Uid_vertex } from './graph_objects';
import { uil_get_world_scaling_factor } from './ui_logic';

export class ImportedModel {
    constructor(vertices_array, faces_array, edges_array, bodies_array) {
        this.vertices = new HashTable();
        this.faces = new HashTable();
        this.edges = new HashTable();
        this.bodies = new HashTable();
        var self = this;
        vertices_array.forEach(function(vid){
            self.vertices.setItem(vid, uid_reference_vertices.getItem(vid));
        });
        faces_array.forEach(function(fid){
            self.faces.setItem(fid, uid_reference_faces.getItem(fid));
        });
        edges_array.forEach(function(eid){
            self.edges.setItem(eid, uid_reference_edges.getItem(eid));
        });
        bodies_array.forEach(function(bid){
            self.bodies.setItem(bid, uid_reference_bodies.getItem(bid));
        });
        this.adjList = new Map();
        this.constructAdjList();
        console.log("Created new model");
    }
    constructAdjList() {
        for (var v of this.vertices.keys()) {
            this.adjList.set(v, new Set());
        }

        for (var eid of this.edges.keys()) {
            var edge = this.edges.getItem(eid);
            this.adjList.get(edge.vertices[0]).add(edge.vertices[1]);
            this.adjList.get(edge.vertices[1]).add(edge.vertices[0]);
        }
    }
    addEdge(ref_edge_obj) {
        var id = 200000 + get_global_id();
        var r, g, b;
        if (ref_edge_obj.source == "stl") {
            r = ref_stl_face_color_r;
            g = ref_stl_face_color_g;
            b = ref_stl_face_color_b;
        }
        else if (ref_edge_obj.source == "parasolid") {
            r = ref_parasolid_face_color_r;
            g = ref_parasolid_face_color_g;
            b = ref_parasolid_face_color_b;
        }
        else { // if (refvObj.source == "partstudio") {
          r = ref_partstudio_face_color_r;
          g = ref_partstudio_face_color_g;
          b = ref_partstudio_face_color_b;
        }
        var uide = new Uid_edge(id, r, g, b);
        ref_edge_obj.set_uid_object(uide);
        this.edges.setItem(uide.id, ref_edge_obj);
        //uid_add_edge_geometry(uide, ref_edge_obj.points, true);
        return (uide.id);
    }
    addFace() {
        var id = 300000 + get_global_id();
        var ref_face_obj = new Uid_ref_face(id, [], [], null, true, 'JHD_phi_1', "partstudio");
        var r, g, b;
        if (ref_face_obj.source == "stl") {
            r = ref_stl_face_color_r;
            g = ref_stl_face_color_g;
            b = ref_stl_face_color_b;
        }
        else if (ref_face_obj.source == "parasolid") {
            r = ref_parasolid_face_color_r;
            g = ref_parasolid_face_color_g;
            b = ref_parasolid_face_color_b;
        }
        else { // if (refvObj.source == "partstudio") {
          r = ref_partstudio_face_color_r;
          g = ref_partstudio_face_color_g;
          b = ref_partstudio_face_color_b;
        }
        var uidf = new Uid_face(id, rgbToHex(r, g, b));
        ref_face_obj.set_uid_object(uidf);
        this.faces.setItem(uidf.id, ref_face_obj);
        return (uidf.id);
    }
    addVertex(refvObj) {
        // Create an id
        var id = 100000 + get_global_id();

        var r, g, b;
        if (refvObj.source == "stl") {
            r = ref_stl_face_color_r;
            g = ref_stl_face_color_g;
            b = ref_stl_face_color_b;
        }
        else if (refvObj.source == "parasolid") {
            r = ref_parasolid_face_color_r;
            g = ref_parasolid_face_color_g;
            b = ref_parasolid_face_color_b;
        }
        else { // if (refvObj.source == "partstudio") {
          r = ref_partstudio_face_color_r;
          g = ref_partstudio_face_color_g;
          b = ref_partstudio_face_color_b;
        }

        // Create new uid vertex object
        var uidv = new Uid_vertex(id, r, g, b);
        refvObj.set_uid_object(uidv);

        // Add uid_ref_vertex object to the vertices hashtable
        this.vertices.setItem(uidv.id, refvObj);

        //console_log("Added to uid_reference_vertices a new reference vertex:", uidv.id);
        //uid_add_vertex_geometry(uidv, refvObj.vertex.x, refvObj.vertex.y, refvObj.vertex.z, true, false);
        return (uidv.id);
    }
    // We return the edges that have less than 3 vertices
    detectIncompleteFaces() {
        var problemEdges = [];
        for (var key of this.faces.keys()) {
            var face = this.faces.getItem(key);
            if (face.edges.length < 3) {
                problemEdges.push(key);
            }
        }
        return problemEdges;
    }
    searchDfs(v1, v2) {
        // Returns the list of edges that connect v1 and v2
        // else it throws an error
        /*
            let S be a stack
            S.push(v)
            while S is not empty do
                v = S.pop()
                if v is not labeled as discovered then
                    label v as discovered
                    for all edges from v to w in G.adjacentEdges(v) do
                        S.push(w)
        */
        var stack = [];
        var discovered = new Set();
        var path = new Map();

        stack.push(v1);
        var found = false;
        while(stack.length > 0) {
            var v = stack.pop();
            if(!discovered.has((v))) {
                discovered.add(v);
                var neighbors = this.adjList.get(v);
                for(var iv of neighbors) {
                    if(!discovered.has(iv)) {
                        path.set(iv, v);
                        if (iv == v2) {
                            found = true;
                            break;
                        }
                        stack.push(iv);
                    }
                }
            }
        }
        if(!found) {
            throw "No path between vertices";
        }
        return path;
    }
    pairwise(list) {
        if (list.length < 2) { return []; }
        var first = list[0],
        rest = list.slice(1),
        pairs = rest.map(function (x) { return [first, x]; });
        return pairs.concat(this.pairwise(rest));
    }
    detectEdgeLooping() {
        // Detect if there is a face where the edges do not form a loop
        // The construct vertex list ensures that there are no incosistencies
        for(var fid of this.faces.keys()){
            try {
                this.constructVertexList(fid);
            } catch (error) {
                throw error;
            }
        }
    }
    detectDisconnectedFaces() {
        // We check that all faces of the graph are connected

        /*
        var pairs = this.pairwise(this.faces.keys());
        for(var pair of pairs) {
            var f0 = this.faces.getItem(pair[0]);
            var f1 = this.faces.getItem(pair[1]);

        }

        var visited = new Set();
        var face = this.faces.getItem(fid);
        var edges = face.edges;
        var edgeSet = new Set(edges);
        var curEdge = edges[0];

        while (1) {
            visited.add(curEdge);
        }
        */
    }

    squashVertices(vid1, vid2) {
        // We squash the two vertices together.
        var v1 = this.vertices.getItem(vid1);
        var v2 = this.vertices.getItem(vid2);

        const threshold = 0.01 ;
        if(v1.vertex.distanceTo(v2.vertex) > threshold) {
            throw "Vertices are not matching"
        }

        // if(v1.edges != v2.edges) {
        //     throw "Vertices do not have the same incidence"
        // }

        // if(v1.edges.length > 1 || v2.edges.length > 1) {
        //     throw "More than one edge"
        // }

        // We replace the reference to vid2 with references to vid1
        this.adjList.forEach( (neighbors, vertex) => {
            if( neighbors.has(vid2) ) {
                neighbors.add(vid1);
                neighbors.delete(vid2);
            }
        })
        //Add the neighbors of vid2 to the adjacency set of vid1
        // Set union of neighbors of v1 and v2
        var a = this.adjList.get(vid1);
        var b = this.adjList.get(vid2);
        let union = new Set([...a, ...b]);

        this.adjList.set(vid1, union);
        this.adjList.delete(vid2);
        this.adjList.get(vid1).delete(vid1);

        var v2edges = []
        for(var eid of this.edges.keys()) {
            var edge = this.edges.getItem(eid);
            var idx = edge.vertices.indexOf(vid2);
            if(idx > -1) {
                edge.vertices[idx] = vid1;
                v2edges.push(eid);
            }
        }
        this.vertices.getItem(vid1).edges = this.vertices.getItem(vid1).edges.concat(v2edges);
        this.vertices.removeItem(vid2);

    }
    squashify() {
        // Perform squashes
        var vtxMap = new Map();

        for(var vid of this.vertices.keys()){
            var vtx = this.vertices.getItem(vid).vertex;
            var vtxCoords = vtx.x + "," + vtx.y + "," + vtx.z
            if(vtxMap.has(vtxCoords)) {
                vtxMap.get(vtxCoords).push(vid);
            }else {
                vtxMap.set(vtxCoords,[vid]);
            }
        }
        var pairs = []

        vtxMap.forEach( (value, _) => {
            if(value.length > 1) {
                pairs.push(value);
            }
        })

        console.log("Squash sequence", pairs)
        for (var pair of pairs) {
            this.squashVertices(pair[0], pair[1]);
        }
    }
    correctFace(fid) {
        var face = this.faces.getItem(fid);
        while (face.edges.length < 3) {
            this.splitEdge(face.edges[0]);
        }
    }
    connectVertices(vid1, vid2) {
        // Connect vertex 1 with vertex 2 using a line
        // Returns an edge object
        var vrtx1 = this.vertices.getItem(vid1);
        var vrtx2 = this.vertices.getItem(vid2);

        var line = new THREE.Line3(vrtx1.vertex, vrtx2.vertex);

        var sampling = 0.01;
        var points = [];
        for(var idx = 0; idx < 1; idx += sampling) {
            var target = new THREE.Vector3();
            line.at(idx, target);
            points.push(target);
        }

        var newEdge = new Uid_ref_edge(vid1 + vid2 + "newEdge", vid1 + vid2, "partstudio");
        newEdge.set_edge_points_array(points);
        newEdge.set_v0(vrtx1.vertex);
        newEdge.set_v1(vrtx2.vertex);

        newEdge.vertices = [vid1, vid2];
        this.adjList.get(vid1).add(vid2);
        this.adjList.get(vid2).add(vid1);

        var newEdgeId = this.addEdge(newEdge);
        vrtx1.edges.splice(0, 0, newEdgeId);
        vrtx2.edges.splice(0, 0, newEdgeId);

        // vrtx1.edges.push(newEdgeId);
        // vrtx2.edges.push(newEdgeId);

        return newEdgeId;
    }

    splitFace(fid, eid1, eid2) {
        // We split the face along the plane defined by the edges eid1, eid2
        var face = this.faces.getItem(fid);
        var edge1 = this.edges.getItem(eid1);
        var edge2 = this.edges.getItem(eid2);

        var plane = new THREE.Plane();

        var vrtxE10 = this.vertices.getItem(edge1.vertices[0]);
        var vrtxE11 = this.vertices.getItem(edge1.vertices[1]);


        var vrtxE20 = this.vertices.getItem(edge2.vertices[0]);
        var vrtxE21 = this.vertices.getItem(edge2.vertices[1]);

        // TODO determine if colinear
        plane.setFromCoplanarPoints(vrtxE10.vertex, vrtxE11.vertex, vrtxE20.vertex);
        //console.log(plane);

        // Calculate points right and left of the plane
        var pointsLeft = [];
        var pointsRight = [];
        var coPlanar = [];
        // Get vertices of face we want to split
        var vertices = this.constructVertexList(fid);
        console.log(vertices);

        for(var vid of vertices) {
            var vrt = this.vertices.getItem(vid);
            var dist = plane.distanceToPoint(vrt.vertex);
            if(dist == 0) {
                coPlanar.push(vid);
            } else if(dist < 0) {
                pointsLeft.push(vid);
            } else if(dist > 0) {
                pointsRight.push(vid);
            }
        }
        console.log("Coplanar", coPlanar, "Left", pointsLeft, "Right", pointsRight);

        // We find the edges with points in the right, left and coplanar

    }
    breakVertexList(vid1, vid2, vtxList) {
        // We break the vtxList to the vertices between vid1 -> vid2 and vid2->vid1
        var idx1 = vtxList.indexOf(vid1);
        if(idx1 < 0) {
            throw "Error breaking vertex list";
        }

        var idx2 = vtxList.indexOf(vid2);
        if (idx2 < 0) {
            throw "Error breaking vertex list";
        }

        // Get all elements from V1 to V2
        var fromV1toV2 = vtxList.slice(idx1, idx2+1);

        var fromV2toV1 = vtxList.slice(idx2, vtxList.length).concat(vtxList.slice(0, idx1+1));

        return [fromV1toV2, fromV2toV1];
    }

    constructVertexList(fid) {
        // Construct list of vertices with the order of edges
        var face = this.faces.getItem(fid);
        var prevIdx = 0;
        var vtxList = [];
        for(var curIdx = 1; curIdx < face.edges.length; curIdx++) {
            var prevEdge = this.edges.getItem(face.edges[prevIdx]);
            var curEdge = this.edges.getItem(face.edges[curIdx]);
            var common = this.commonVertex(prevEdge, curEdge);
            if(common < 0) {
                throw "Incosistent face";
            }
            else {
                if(common == prevEdge.vertices[0]) {
                    vtxList.push(prevEdge.vertices[1])
                } else if (common == prevEdge.vertices[1]){
                    vtxList.push(prevEdge.vertices[0])
                }
            }
        }

        var prevEdge = this.edges.getItem(face.edges[face.edges.length - 1]);
        var curEdge = this.edges.getItem(face.edges[0]);
        var common = this.commonVertex(prevEdge, curEdge);
        if (common < 0) {
            throw "Incosistent face";
        }
        else {
            if (common == prevEdge.vertices[0]) {
                vtxList.push(prevEdge.vertices[1])
            } else if (common == prevEdge.vertices[1]) {
                vtxList.push(prevEdge.vertices[0])
            }
        }

        return vtxList;
    }
    findEdge(vid1, vid2) {
        // Return the edgeId of the edge with vertices vid1, vid2
        for(var eid of this.edges.keys()){
            var edge = this.edges.getItem(eid);
            var edgeSet = new Set(edge.vertices);
            if(edgeSet.has(vid1) && edgeSet.has(vid2)) {
                return eid;
            }
        }
        throw "No matching edge";
    }
    makeFace(vtxList1, eid1, vtxList2, eid2, fthr) {
        // Make a new face
        var vtxOrdering = vtxList1;
        var edge1 = this.edges.getItem(eid1);
        var edge2 = this.edges.getItem(eid2);
        var last = vtxOrdering[vtxOrdering.length - 1];
        var edge1used = false;
        var edge2used = false;
        vtxList2.reverse();

        if ((last == edge1.vertices[0]) || (last == edge1.vertices[1])) {
            edge1used = true;
            if(last == edge1.vertices[0]) {
                vtxOrdering.push(edge1.vertices[0]);
                vtxOrdering.push(edge1.vertices[1]);
            }
            else if(last == edge1.vertices[1]) {
                vtxOrdering.push(edge1.vertices[0]);
                vtxOrdering.push(edge1.vertices[1]);
            }
        }
        else if ((last == edge2.vertices[0]) || (last == edge2.vertices[1])) {
            if (last == edge1.vertices[0]) {
                vtxOrdering.push(edge1.vertices[0]);
                vtxOrdering.push(edge1.vertices[1]);
            }
            else if (last == edge1.vertices[1]) {
                vtxOrdering.push(edge1.vertices[0]);
                vtxOrdering.push(edge1.vertices[1]);
            }
            edge2used = true;
        }

        vtxOrdering = vtxOrdering.concat(vtxList2);
        last = vtxOrdering[vtxOrdering.length - 1];
        if(edge1used) {
            if (last == edge2.vertices[0]) {
                vtxOrdering.push(edge1.vertices[0]);
                vtxOrdering.push(edge1.vertices[1]);
            }
            else if (last == edge2.vertices[1]) {
                vtxOrdering.push(edge1.vertices[0]);
                vtxOrdering.push(edge1.vertices[1]);
            }
        } else if(edge2used) {
            if (last == edge1.vertices[0]) {
                vtxOrdering.push(edge1.vertices[0]);
                vtxOrdering.push(edge1.vertices[1]);
            }
            else if (last == edge1.vertices[1]) {
                vtxOrdering.push(edge1.vertices[0]);
                vtxOrdering.push(edge1.vertices[1]);
            }
        }

        vtxOrdering = [...new Set(vtxOrdering)];
        console.log("New face vtx ordering", vtxOrdering);
        var edgeList = [];
        for(var i = 1;i < vtxOrdering.length; i++) {
            try {
                var edge = this.findEdge(vtxOrdering[i], vtxOrdering[i-1]);
                edgeList.push(edge);
            } catch (error) {
                console.log(error)
            }
        }
        try {
            var edge = this.findEdge(vtxOrdering[vtxOrdering.length - 1], vtxOrdering[0]);
            edgeList.push(edge);
        } catch (error) {
            console.log(error)
        }
        console.log("New face edge list:", edgeList);
        var newFaceId = this.addFace();
        var face = this.faces.getItem(newFaceId);
        face.edges = edgeList ;
        edge1.faces.push(newFaceId);
        edge2.faces.push(newFaceId);

        for(var eid of edgeList){
            var edge = this.edges.getItem(eid);
            var idx = edge.faces.indexOf(fthr);
            if(idx > -1) {
                edge.faces.splice(idx, 1, newFaceId);
            }
        }
    }
    checkDistances() {
        // We ensure that all edges the vertices distance is greater than e-3 and
        // that the samples are distanced at least e-3 apart

        for (var eid of this.edges.keys()) {
            var edge = this.edges.getItem(eid);
            var vtx0 = this.vertices.getItem(edge.vertices[0]);
            var vtx1 = this.vertices.getItem(edge.vertices[1]);

            const THRESHOLD = 0.001

            if(vtx0.vertex.distanceTo(vtx1.vertex) < THRESHOLD) {
                throw "Edge too small " + eid;
            }

            if(edge.points.length == 2) {
                if (edge.points[0].distanceTo(edge.points[1])) {
                    throw "Edge too small " + eid;
                }
            }
            else {
                for(var i = 0; i < edge.points.length; i++) {
                    for(var j=i+1; j< edge.points.length; j++){
                        if(edge.points[i].distanceTo(edge.points[j])) {
                            throw "Samples in edge too close " + eid;
                        }
                    }
                }
            }
        }
    }
    connectFace(fid1, fid2, fthr) {
        // Connect face with id1 and id2 going through fthrough
        var face1 = this.faces.getItem(fid1);
        var face2 = this.faces.getItem(fid2);

        var edgesF1 = face1.edges;
        var edgesF2 = face2.edges;

        var vertsF1 = this.constructVertexList(fid1);
        var vertsF2 = this.constructVertexList(fid2);

        var brokenF1 = this.breakVertexList(vertsF1[0], vertsF1[1], vertsF1);
        var brokenF2 = this.breakVertexList(vertsF2[0], vertsF2[1], vertsF2);

        console.log("Vertex ordering of face 1:", vertsF1);
        console.log("Vertex ordering of face 2:", vertsF2);

        console.log("Broken f1", brokenF1);
        console.log("Broken f2", brokenF2);

        var edge1 = this.connectVertices(vertsF1[0], vertsF2[0]);
        var edge2 = this.connectVertices(vertsF1[1], vertsF2[1]);
        this.makeFace(brokenF1[0], edge1, brokenF2[0], edge2, fthr);
        this.makeFace(brokenF1[1], edge1, brokenF2[1], edge2, fthr);

        this.faces.removeItem(fthr);

    }
    commonVertex(edge1, edge2) {
        // Find the common vertex if it exists of edge 1 and edge2
        var edge1verts = edge1.vertices;
        var edge2verts = edge2.vertices;

        if(edge1verts[0] == edge2verts[0] || edge1verts[0] == edge2verts[1]) {
            return edge1verts[0];
        }
        if (edge1verts[1] == edge2verts[0] || edge1verts[1] == edge2verts[1]) {
            return edge1verts[1];
        }
        return -1;
    }
    splitEdge(eid) {
        /*
            1. Find the edge we want to split
            2. Choose the mid point from the samples
            3. Determine the direction of samples
            4. Split the samples in two
            5. Create two new edges
            6. Determine order for the two new edges
            7. Update face description of the two faces
        */

        // Split the edge with edge id
        var edge = this.edges.getItem(eid);
        console.log("Spliting edge", eid);

        // Check if the existing edge samples go from the first to the second vertex, or in the opposite direction
        // We set the order of the array of samples
        var eV0 = edge.v0;
        var n = edge.points.length;
        if(n == 2) {
            // In case we have a line we resample it
            n = this.sampleLine(edge);
        }

        // Create new vertex and two new edges
        var midPoint = new THREE.Vector3();
        var leftPoints = [];
        var rightPoints = [];
        var midIdx = Math.floor(n / 2); // Index of the mid element used for the split
        midPoint.copy(edge.points[midIdx]);

        leftPoints = edge.points.slice(0, midIdx+1);
        rightPoints = edge.points.slice(midIdx, n);

        var vtan1 = new THREE.Vector3(); // The tangent vector corresponding to vertex v0
        var vtan2 = new THREE.Vector3(); // The tangent vector corresponding to vertex v1

        // Create new vertex and the two new edges

        // Create new vertex object at midPoint
        var vObj = new Uid_ref_vertex(edge.onshape_id + "newV", midPoint, edge.onshape_body_id, "partstudio");
        var vid = this.addVertex(vObj);

        // Update the adjacency list
        var leftVid = edge.vertices[0];
        var rightVid = edge.vertices[1];
        this.adjList.get(leftVid).add(vid);
        this.adjList.get(rightVid).add(vid);
        this.adjList.set(vid, new Set([leftVid, rightVid]));


        // Create two new edges
        var e1Obj = new Uid_ref_edge(edge.onshape_id + "newE1", edge.onshape_body_id, "partstudio");
        e1Obj.set_edge_points_array(leftPoints);
        e1Obj.set_v0(edge.v0);
        e1Obj.set_v1(midPoint);
        e1Obj.vertices.push(edge.vertices[0], vid);


        var e2Obj = new Uid_ref_edge(edge.onshape_id + "newE2", edge.onshape_body_id, "partstudio");
        e2Obj.set_edge_points_array(rightPoints);
        e2Obj.set_v0(midPoint);
        e2Obj.set_v1(edge.v1);
        e2Obj.vertices.push(vid, edge.vertices[1]);

        // Ids of the newly created edges
        var ide1 = this.addEdge(e1Obj);
        var ide2 = this.addEdge(e2Obj);

        this.vertices.getItem(vid).edges.push(ide1);
        this.vertices.getItem(vid).edges.push(ide2);


        // We must check in which order these edges must be added around the face.
        // We first get the position of the edge on the list of edges for each face
        var face0 = this.faces.getItem(edge.faces[0]);
        var face1 = this.faces.getItem(edge.faces[1]);

        var eind0 = face0.edges.indexOf(eid);
        var eind1 = face1.edges.indexOf(eid);

        // We get the index of the previous edge, if our edge is the first we use the last element of the array
        var ef0prevIdx = (eind0 == 0) ? (face0.edges.length - 1) : (eind0 - 1)
        var ef1prevIdx = (eind1 == 0) ? (face1.edges.length - 1) : (eind1 - 1)

        var ef0prevId = face0.edges[ef0prevIdx];
        var ef1prevId = face1.edges[ef1prevIdx];

        var ef0prev = this.edges.getItem(ef0prevId);
        var ef1prev = this.edges.getItem(ef1prevId);

        // We determine the correct position by comparing the distances between the last index of the previous
        // edge and the first index of the newly created edges
        // console.log(ef0prev.v0, ef0prev.v1);
        // console.log(ef1prev.v0, ef1prev.v1);

        // console.log(e1Obj.v0, e1Obj.v1);
        // console.log(e2Obj.v0, e2Obj.v1);

        var ef0order = [];
        if(this.commonVertex(ef0prev, e1Obj) > 0) {
            ef0order.push(ide1, ide2);
        } else if(this.commonVertex(ef0prev, e2Obj) > 0) {
            ef0order.push(ide2, ide1);
        } else {
            console.log("no matching vertex");
            ef0order.push(ide1, ide2);
        }

        var ef1order = [];
        if (this.commonVertex(ef1prev, e1Obj) > 0) {
            ef1order.push(ide1, ide2);
        } else if (this.commonVertex(ef1prev, e2Obj) > 0) {
            ef1order.push(ide2, ide1);
        } else {
            console.log("no matching vertex");
            ef1order.push(ide1, ide2);
        }

        console.log("orders", ef0order, ef1order);

        // We update the edges hashtable
        // We add the newly created edges and remove the old one
        this.edges.setItem(ide1, e1Obj);
        this.edges.setItem(ide2, e2Obj);

        // We update the faces hashtable and remove the old edge from the list of edges
        var index = face0.edges.indexOf(eid);
        if (index > -1) {
            face0.edges.splice(index, 1, ef0order[0], ef0order[1]);
        }
        index = face1.edges.indexOf(eid);
        if (index > -1) {
            face1.edges.splice(index, 1, ef1order[0], ef1order[1]);
        }

        this.vertices.setItem(vid, vObj);

        e1Obj.add_face(edge.faces[0]);
        e1Obj.add_face(edge.faces[1]);

        e2Obj.add_face(edge.faces[0]);
        e2Obj.add_face(edge.faces[1]);

        var v0id = this.edges.getItem(eid).vertices[0];
        var v1id = this.edges.getItem(eid).vertices[1];
        var v0 = this.vertices.getItem(v0id);
        var v1 = this.vertices.getItem(v1id);

        var eidx = v0.edges.indexOf(eid);
        if(eidx > -1) {
            v0.edges.splice(eidx, 1, ide1);
        }

        eidx = v1.edges.indexOf(eid);
        if (eidx > -1) {
            v1.edges.splice(eidx, 1, ide2);
        }
        this.edges.removeItem(eid);
    }
    sampleLine(edge) {
        var v0id = edge.vertices[0];
        var v1id = edge.vertices[1];

        var v0 = this.vertices.getItem(v0id);
        var v1 = this.vertices.getItem(v1id);


        var line = new THREE.Line3(v0.vertex, v1.vertex);
        var sampling = 0.01;
        var samples = [];
        for(var i = 0;i <= 1; i+=sampling){
            var vec = new THREE.Vector3();
            line.at(i, vec);
            samples.push(vec);
        }
        edge.points = samples;
        return samples.length;
    }
    exportToXML() {
        uid_reference_bodies = this.bodies;
        uid_reference_edges = this.edges;
        uid_reference_faces = this.faces;
        uid_reference_vertices = this.vertices;

        var tmp_reference_bodies = this.bodies.keys();
        var tmp_reference_edges = this.edges.keys();
        var tmp_reference_faces = this.faces.keys();
        var tmp_reference_vertices = this   .vertices.keys();

        console.log("edges", uid_reference_edges);
        console.log("bodies", uid_reference_bodies);
        console.log("faces", uid_reference_faces);
        console.log("vertices", uid_reference_vertices);


        var force_everything_in_single_body = false;
        var model_ok = true;
        //   // Generate a new ID for the 2nd face, in case we are in force_everything_in_single_body mode
        var first_face_id;
        var second_face_id;
        if (force_everything_in_single_body) {
            first_face_id = uid_reference_faces.getItem(tmp_reference_faces[0]).id;
            second_face_id = get_global_id();
            // Also mark the ID of the inward facing face so we can subsequently pop-it-out.
            // XXX outward_looking_converted_face_label.v = rf.onshape_id;
            // XXX inward_looking_converted_face_label.v = second_face_id;
        }

        var phi_string = '';

        phi_string += '<case_description><version>10</version><scale_fac>' + uil_get_world_scaling_factor() + '</scale_fac>';

        phi_string += '<bodies>';
        tmp_reference_bodies.forEach(function (b_label) {
            if (!force_everything_in_single_body)
                phi_string += '<body label="' + b_label + '"><id>' + uid_reference_bodies.getItem(b_label) + '</id>';
            else
                phi_string += '<body label="' + b_label + '"><id>' + b_label + '</id>';
            phi_string += '<face_ids>';

            var i = 0; // A counter so we can identify the 2nd face
            tmp_reference_faces.forEach(function (rf_id) {
                var rf = uid_reference_faces.getItem(rf_id);
                if (!force_everything_in_single_body) {
                    if (rf.onshape_body_id == b_label) {
                        phi_string += '<face_id>' + rf.id + '</face_id>';
                    }
                }
                else {
                    if (i == 1)
                        phi_string += '<face_id>' + second_face_id + '</face_id>';
                    else
                        phi_string += '<face_id>' + rf.id + '</face_id>';
                }
                i++;
            });
            phi_string += '</face_ids>';
            phi_string += '<open>0</open></body>';
        });
        phi_string += "</bodies>";


        phi_string += "<faces>";
        var i = 0;
        tmp_reference_faces.forEach(function (rf_id) {
            var rf = uid_reference_faces.getItem(rf_id);
            if (!force_everything_in_single_body)
                phi_string += '<face label="' + rf.onshape_id + '"><id>' + rf.id + '</id><body_id>' + uid_reference_bodies.getItem(rf.onshape_body_id) + '</body_id>';
            else {
                if (force_everything_in_single_body && i == 1)
                    phi_string += '<face label="' + second_face_id + '"><id>' + second_face_id + '</id><body_id>' + tmp_reference_bodies[0] + '</body_id>';
                else
                    phi_string += '<face label="' + rf.onshape_id + '"><id>' + rf.id + '</id><body_id>' + tmp_reference_bodies[0] + '</body_id>';
            }

            phi_string += '<edge_ids>';

            if (force_everything_in_single_body) {
                if (i == 1) {
                    // Add edges in the reverse order
                    var earr = [...rf.edges];
                    earr.reverse();
                    earr.forEach(function (eid) {
                        phi_string += '<edge_id>' + uid_reference_edges.getItem(eid).id + '</edge_id>';
                    });
                }
                else {
                    rf.edges.forEach(function (eid) {
                        phi_string += '<edge_id>' + uid_reference_edges.getItem(eid).id + '</edge_id>';
                    });
                }
            }
            else {
                // XXX XXX XXX DEBUG HACK ---->>>
                // if (rf.id != 18)
                //    rf.edges.reverse();
                // XXX XXX XXX <<<-----
                rf.edges.forEach(function (eid) {
                    phi_string += '<edge_id>' + uid_reference_edges.getItem(eid).id + '</edge_id>';
                });
            }
            phi_string += '</edge_ids>';

            phi_string += '<crib_gamma>29.000000</crib_gamma>'; // XXX

            // We will NOT be making one of the two faces invisible, as this will create confusion more than help.
            /*
            if (force_everything_in_single_body && i == 1 )
            phi_string += '<visible>0</visible>';
            else
            phi_string += '<visible>1</visible>';
            */
            phi_string += '<visible>1</visible>';
            phi_string += '<fixed>0</fixed>';

            if (force_everything_in_single_body && i == 1)
                phi_string += '<label>' + second_face_id + '</label>';
            else
                phi_string += '<label>' + rf.onshape_id + '</label>';

            /*
            // Make the first face green and the second one red (red should be pointing inwards in the body)
            // No we don't do this any more.
            if (force_everything_in_single_body && i == 1 )
            phi_string += '<R>200</R><G>75</G><B>100</B>';
            else if (force_everything_in_single_body && i != 1 )
            phi_string += '<R>75</R><G>100</G><B>200</B>';
            else
            phi_string += '<R>-1</R><G>-1</G><B>-1</B>';
            */
            phi_string += '<R>-1</R><G>-1</G><B>-1</B>';

            phi_string += '<material></material>';

            phi_string += '</face>';
            i++;
        });
        phi_string += "</faces>";

        phi_string += '<edges>';
        tmp_reference_edges.forEach(function (re_id) {
            var re = uid_reference_edges.getItem(re_id);
            phi_string += '<edge label="' + re.onshape_id + '"><id>' + re.id + '</id>';
            phi_string += '<vertex1_id>' + uid_reference_vertices.getItem(re.vertices[0]).id + '</vertex1_id>';
            phi_string += '<vertex2_id>' + uid_reference_vertices.getItem(re.vertices[1]).id + '</vertex2_id>';
            if (!force_everything_in_single_body) {
                phi_string += '<face1_id>' + uid_reference_faces.getItem(re.faces[0]).id + '</face1_id>';
                phi_string += '<face2_id>' + uid_reference_faces.getItem(re.faces[1]).id + '</face2_id>';
            }
            else {
                phi_string += '<face1_id>' + first_face_id + '</face1_id>';
                phi_string += '<face2_id>' + second_face_id + '</face2_id>';
            }
            phi_string += '<curve><id>' + get_global_id() + '</id>';

            // First of all, we remove every other sample except the first and last from the re.points array, as it comes in as
            // [p1, p2, p2, p3, p3, p4, p4, p5.... pn-1, pn]


            var arr = [];
            arr = [...re.points];

            /*
            arr.forEach(function(p){
            add_small_ball(p.x, p.y, p.z, 0, 255, 0, 0.2);
            });
            */

            for (var i = arr.length - 3; i > 0; i -= 2) {
                arr.splice(i, 1);
            }

            // Set v0 and v1 vectors.
            var v_last = arr[arr.length - 1];
            var v_one_before_last = arr[arr.length - 2];
            var v_first = arr[0];
            var v_second = arr[1];
            var approximate_v0 = new THREE.Vector3();
            var approximate_v1 = new THREE.Vector3();
            approximate_v0.subVectors(v_second, v_first);
            approximate_v1.subVectors(v_last, v_one_before_last);

            var va = new THREE.Vector3();
            var vb = new THREE.Vector3();
            va.copy(re.v0);
            vb.copy(re.v1);

            if (approximate_v0.dot(va) > approximate_v0.dot(vb)) {
                phi_string += '<v0><vector3d><x>' + va.x + '</x><y>' + va.y + '</y><z>' + va.z + '</z></vector3d></v0>'; // XXX
                phi_string += '<v1><vector3d><x>' + vb.x + '</x><y>' + vb.y + '</y><z>' + vb.z + '</z></vector3d></v1>'; // XXX
            }
            else {
                phi_string += '<v0><vector3d><x>' + vb.x + '</x><y>' + vb.y + '</y><z>' + vb.z + '</z></vector3d></v0>'; // XXX
                phi_string += '<v1><vector3d><x>' + va.x + '</x><y>' + va.y + '</y><z>' + va.z + '</z></vector3d></v1>'; // XXX
            }
            phi_string += '<g0><vector3d><x>' + 0 + '</x><y>' + 0 + '</y><z>' + 0 + '</z></vector3d></g0>'; // XXX
            phi_string += '<g1><vector3d><x>' + 0 + '</x><y>' + 0 + '</y><z>' + 0 + '</z></vector3d></g1>'; // XXX
            phi_string += '<interpts>';
            var id = 1;

            // Make sure we have enough samples in the "points" array. Set limit to 10

            // Only resampling input array if less than 5 samples
            var done_here = false;
            while (arr.length < 5 && !done_here) {
                var length_before = arr.length;
                arr = fill_up_sample_array(arr);
                if (arr.length == length_before)
                    // Failed to add more samples, we're done here
                    done_here = true;
            }
            //

            //console_log("Reference edge with ID: " + id + " has " + arr.length + " samples.");

            // Replace the first and last samples with the vertex coordinates to make sure there are no discrepancies.
            if (arr[0].distanceTo(uid_reference_vertices.getItem(re.vertices[0]).vertex) <
                arr[0].distanceTo(uid_reference_vertices.getItem(re.vertices[1]).vertex)) {
                arr[0].copy(uid_reference_vertices.getItem(re.vertices[0]).vertex);
                arr[arr.length - 1].copy(uid_reference_vertices.getItem(re.vertices[1]).vertex);
            }
            else {
                arr[0].copy(uid_reference_vertices.getItem(re.vertices[1]).vertex);
                arr[arr.length - 1].copy(uid_reference_vertices.getItem(re.vertices[0]).vertex);
            }

            // Make sure that we don't have any samples too close to the 1st/last one

            var local_epsilon = 1e-4;

            var done = false;
            while (!done && arr.length > 2) {
                if (maths.proximate(arr[1].distanceTo(arr[0]), 0, local_epsilon))
                    arr.splice(1, 1);
                else
                    done = true;
            }
            done = false;
            while (!done && arr.length > 2) {
                if (maths.proximate(arr[arr.length - 1].distanceTo(arr[arr.length - 2]), 0, local_epsilon))
                    arr.splice(arr.length - 2, 1);
                else
                    done = true;
            }

            if (arr.length < 5) {
                model_ok = false;
                var error_message = 'Edge ' + re.onshape_id + ' has very short length. Interrupting operation.';
                display_message_to_user(LOG.WARN, error_message);
            }

            arr.forEach(function (p) {
                //add_small_ball(p.x, p.y, p.z, 255, 0, 0, 0.1);
                phi_string += '<interpt>';
                phi_string += '<id>' + id++ + '</id><coords><vector3d>';
                phi_string += '<x>' + p.x + '</x><y>' + p.y + '</y><z>' + p.z + '</z>';
                phi_string += '</vector3d></coords>';
                phi_string += '</interpt>';
            });
            phi_string += '</interpts>';
            phi_string += '<nsim>12</nsim>';
            phi_string += '</curve>';
            phi_string += '<smoothness_flag>0</smoothness_flag>';
            phi_string += '<smoothness>-1</smoothness>';
            phi_string += '<linear>0</linear>';
            phi_string += '<visible>1</visible>';
            phi_string += '<fixed>0</fixed>';
            phi_string += '</edge>';
        });
        phi_string += '</edges>';

        phi_string += '<vertices>';
        tmp_reference_vertices.forEach(function (rv_id) {
            var rv = uid_reference_vertices.getItem(rv_id);
            if (rv.edges.length > 0) {
                // We reject vertices with no edges on them
                phi_string += '<vertex label="' + rv.onshape_id + '"><id>' + rv.id + '</id>';
                phi_string += '<coords><vector3d><x>' + rv.vertex.x + '</x><y>' + rv.vertex.y + '</y><z>' + rv.vertex.z + '</z></vector3d></coords>';
                phi_string += '<normal><vector3d><x>0</x><y>0</y><z>0</z></vector3d></normal>';
                phi_string += '<smoothness_flag>0</smoothness_flag><smoothness>0</smoothness>';
                phi_string += '<edge_ids>';

                /* We saw that Onshape passes the edges in either random or reverse order. We'll handle this in two steps. First we will order them
                    in a loop around the vertex, and then we will check if we need to reverse the order. First the loop. */
                var edges_array = [...rv.edges];
                var face_edges = new HashTable();
                var edge_faces = new HashTable();

                if (!force_everything_in_single_body) {
                    // Create a list of all faces sharing this edge (and vertex)
                    tmp_reference_faces.forEach(function (rf_id) {
                        var rf = uid_reference_faces.getItem(rf_id);
                        var face_contains_edge = false;
                        rf.edges.forEach(function (re) {
                            if (edges_array.indexOf(re) != -1) {
                                face_contains_edge = true;
                                var a = face_edges.getItem(rf.uid_object.id);
                                if (a)
                                    a.push(re);
                                else
                                    a = [re];
                                face_edges.setItem(rf.uid_object.id, a);

                                a = edge_faces.getItem(re);
                                if (a)
                                    a.push(rf.uid_object.id);
                                else
                                    a = [rf.uid_object.id];
                                edge_faces.setItem(re, a);
                            }
                        });
                    });

                    // Start from first edge.
                    var sorted_edges = [];
                    var current_edge = face_edges.firstValue()[0];
                    var current_face = edge_faces.getItem(current_edge)[0];
                    edges_array.splice(edges_array.indexOf(current_edge), 1);
                    sorted_edges.push(current_edge);

                    while (edges_array.length > 0) {
                        if (current_edge == face_edges.getItem(current_face)[0])
                            current_edge = face_edges.getItem(current_face)[1];
                        else
                            current_edge = face_edges.getItem(current_face)[0];

                        if (current_face == edge_faces.getItem(current_edge)[0])
                            current_face = edge_faces.getItem(current_edge)[1];
                        else
                            current_face = edge_faces.getItem(current_edge)[0];

                        // PROCESS THEM
                        edges_array.splice(edges_array.indexOf(current_edge), 1);
                        sorted_edges.push(current_edge);
                    }

                    /* We may need to reverse the order of edges in rv.edges, so we must make sure that they go around in a
                    direction pointing outwards according to the right-hand rule. To do this, we take the first two consecutive
                    edges, then look for them in another face and make sure they appear in the opposite order. */

                    //var arr = [... rv.edges];
                    var arr = sorted_edges;
                    var must_reverse = false;
                    var found_pair = false;
                    var e1 = arr[0];
                    var e2 = arr[1];
                    tmp_reference_faces.forEach(function (rf_id) {
                        var rf = uid_reference_faces.getItem(rf_id);
                        for (var i = 0; i < rf.edges.length && !found_pair; i++) {
                            var ii = i < rf.edges.length - 1 ? i + 1 : 0;
                            if (rf.edges[i] == e1 && rf.edges[ii] == e2) {
                                found_pair = true;
                                must_reverse = true;
                                console_log("Must reverse " + rv.id);
                            }
                            else if (rf.edges[i] == e2 && rf.edges[ii] == e1) {
                                found_pair = true;
                                must_reverse = false;
                                console_log("Must not reverse " + rv.id);
                            }
                        }
                    });

                    if (must_reverse) {
                        console_log("Reversing array:" + arr);
                        arr.reverse();
                        console_log("Reversed array is:" + arr);
                    }
                }
                else {
                    // Just check if the edges in rv.edges belong in the first face.
                    var face1 = uid_reference_faces.getItem(tmp_reference_faces[0]);
                    var arr = [];
                    rv.edges.forEach(function (eid) {
                        if (face1.edges.indexOf(eid) != -1) {
                            arr.push(eid);
                        }
                    });
                    arr = [... new Set(arr)];
                }

                arr.forEach(function (e) {
                    phi_string += '<edge_id>' + uid_reference_edges.getItem(e).id + '</edge_id>';

                });
                phi_string += '</edge_ids>';
                phi_string += '<smooth_edge_pairs></smooth_edge_pairs>';
                phi_string += '<visible>1</visible>';
                phi_string += '<fixed>0</fixed>';
                phi_string += '</vertex>';
            }
        });

        if (!model_ok) {
            console_log_xml("Aborted generating phi model from onshape part studio");
            return null;
        }

        phi_string += '</vertices>';
        phi_string += '<extra_data_len>0</extra_data_len><extra_data></extra_data>';

        phi_string += '</case_description>';

        //console_log_xml("PHI STRING:");
        //console_log_xml(phi_string);

        // Prepend header to the string
        var complete_string = "Phi;00001;000000005f747f0e;0001;0001;0001;000;;0001;";
        var n = decimalToHex(phi_string.length, 16);
        complete_string += n + ";" + n + ";" + phi_string;

        console_log_xml("COMPLETE PHI STRING:");
        console_log_xml(complete_string);
        console.log(complete_string);
        return complete_string;
    }
    represent() {
        console.log("-----------------------");
        console.log("Number of bodies", this.bodies.length);
        console.log("Number of edges", this.edges.length);
        console.log("Number of vertices", this.vertices.length);
        console.log("Number of faces", this.faces.length);
        console.log("-----------------------");
        console.log("EDGES");
        for (var eid of this.edges.keys()) {
            var edge = this.edges.getItem(eid);
            console.log("edge", eid, "[", edge.vertices[0], ",", edge.vertices[1], "] belonging to:", edge.faces);
        }

        console.log("FACES");
        for (var fid of this.faces.keys()) {
            var face = this.faces.getItem(fid);
            console.log("face", fid, "edges:", face.edges);
        }

        console.log("VERTICES");
        for (var vid of this.vertices.keys()) {
            var vertex = this.vertices.getItem(vid);
            console.log("vid:", vid, "vertex", vertex.vertex, "edges:", vertex.edges, "");
        }
        console.log("ADJ LIST", this.adjList);
    }
    checkVertexEdgeConsistency() {
        // We make sure all vertices have references to the edges they are a part of
        var vtxToEdge = new Map();
        for(var eid of this.edges.keys()){
            var edge = this.edges.getItem(eid);
            var vtx0 = edge.vertices[0];
            var vtx1 = edge.vertices[1];

            if(vtxToEdge.has(vtx0)) {
                vtxToEdge.get(vtx0).add(eid);
            }else {
                var edges = new Set([eid]);
                vtxToEdge.set(vtx0, edges);
            }
            if (vtxToEdge.has(vtx1)) {
                vtxToEdge.get(vtx1).add(eid);
            } else {
                var edges = new Set([eid]);
                vtxToEdge.set(vtx1, edges);
            }
        }

        for(var vid of this.vertices.keys()){
            var vtx = this.vertices.getItem(vid);
            var edgeSet = new Set([...vtx.edges]);
            var edgeSetCmp = vtxToEdge.get(vid);

            let a_minus_b = new Set([...edgeSetCmp].filter(x => !edgeSet.has(x)));
            let b_minus_a = new Set([...edgeSet].filter(x => !edgeSetCmp.has(x)));

            if (a_minus_b.length > 0 || b_minus_a.length > 0) {
                throw "Incosistent vertices-edge pairs";
            }
        }
    }
    checkFaceEdgeConsistency() {
        // We make sure all vertices have references to the edges they are a part of
        var faceToEdge = new Map();
        var vtxToEdge = new Map(); // XXX
        for (var eid of this.edges.keys()) {
            var edge = this.edges.getItem(eid);
            var vtx0 = edge.vertices[0];
            var vtx1 = edge.vertices[1];

            if (vtxToEdge.has(vtx0)) {
                vtxToEdge.get(vtx0).add(eid);
            } else {
                var edges = new Set([eid]);
                vtxToEdge.set(vtx0, edges);
            }
            if (vtxToEdge.has(vtx1)) {
                vtxToEdge.get(vtx1).add(eid);
            } else {
                var edges = new Set([eid]);
                vtxToEdge.set(vtx1, edges);
            }
        }

        for (var vid of this.vertices.keys()) {
            var vtx = this.vertices.getItem(vid);
            var edgeSet = new Set([...vtx.edges]);
            var edgeSetCmp = vtxToEdge.get(vid);

            let a_minus_b = new Set([...edgeSetCmp].filter(x => !edgeSet.has(x)));
            let b_minus_a = new Set([...edgeSet].filter(x => !edgeSetCmp.has(x)));

            if (a_minus_b.length > 0 || b_minus_a.length > 0) {
                throw "Incosistent vertices-edge pairs";
            }
        }
    }
    checkConnectedFace(fid) {
        // We check that all faces are connected


    }
}

export function generate_phi_model_from_onshape_part_studio_details_NEW(tmp_reference_vertices, tmp_reference_edges,
    tmp_reference_faces, tmp_reference_bodies) {
    console.log("Generating phi model");
    console.log(tmp_reference_edges, tmp_reference_faces, tmp_reference_vertices, tmp_reference_bodies);
    console.log("edges", uid_reference_edges);
    console.log("bodies", uid_reference_bodies);
    console.log("faces", uid_reference_faces);
    console.log("vertices", uid_reference_vertices);

    //model = new ImportedModel(uid_reference_vertices, uid_reference_faces, uid_reference_edges, uid_reference_bodies);
    var model = new ImportedModel(tmp_reference_vertices, tmp_reference_faces, tmp_reference_edges, tmp_reference_bodies);

    var problemFaces = model.detectIncompleteFaces();
    console.log(model.edges.keys().length);
    console.log("Detected the following problematic edges", problemFaces);
    model.represent();

    for (var    face of problemFaces) {
        model.correctFace(face);
    }

    // FOR CYLINDER
    var squashSeq = model.squashify();
    //model.represent();

    if(model.faces.keys().length == 3) {
        // CYLINDER
        var newEdgeId = model.connectFace(300019, 300023, 300021);
        // model.faces.getItem(300023).edges = [20049, 20043, 20048];
        // model.faces.getItem(300019).edges = [20037, 20031, 20036];
        // model.faces.getItem(300054).edges = [20037, 20051, 20049, 20053];
        // model.faces.getItem(300056).edges = [20036, 20053, 20048, 20043, 20051, 20031];
        model.constructAdjList();
        console.log(model.adjList);
    } else if (model.faces.keys().length == 4) {
        //model.faces.getItem(300034).edges =
    } else {
        // NON CYLINDER
        //model.splitEdge(200070);
        // shuffle(model.vertices.getItem(100045).edges);
        // shuffle(model.vertices.getItem(100047).edges);

        // shuffle(model.faces.getItem(300058).edges);
        // shuffle(model.faces.getItem(300066).edges);

        // model.splitEdge(200073);
    }
    model.checkVertexEdgeConsistency();
    model.represent();

    var xmlPhi = model.exportToXML();
    return xmlPhi;

}
// https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
// Used for testing incorrect vertex ordering hypotheses
export function shuffle(array) {
    let currentIndex = array.length, randomIndex;

    // While there remain elements to shuffle...
    while (currentIndex != 0) {

        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
    }

    return array;
}
